<template>
    <vue-code-highlight :language="lang">{{ text }}</vue-code-highlight>
</template>

<script>
import { component as VueCodeHighlight } from "vue-code-highlight";
import 'prism-es6/components/prism-markup-templating';
import 'prism-es6/components/prism-csharp';
import 'prism-es6/components/prism-python';
import 'prism-es6/components/prism-php';
import "@/assets/prism-nord.css";

export default {
    props: ["lang", "text"],
    components: { VueCodeHighlight }
}
</script>